<div *ngIf="dataLoading">
  <h3 style="text-align:center;">LOADING READY/PICKUP</h3>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<div class="container" style="width:100%" *ngIf="!dataLoading && orders.length">
  <mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="status"
    matSortDirection="asc"
    class="mat-elevation-z2 job-ready-table"
  >
    <ng-container matColumnDef="alert">
      <mat-header-cell *matHeaderCellDef fxFlex="0 0 40px"></mat-header-cell>
      <mat-cell *matCellDef="let order" fxFlex="0 0 40px" class="stack-alert-cell">
        <mat-icon color="warn" *ngIf="order.redoPriority">notification_important</mat-icon>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 140px"> STATUS </mat-header-cell>
      <mat-cell *matCellDef="let order" fxFlex="0 0 140px" class="stack-wrap-cell">
        <strong>{{ statusLabel(order) }}</strong>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="vendor">
      <mat-header-cell *matHeaderCellDef fxFlex="1 1 14%"> VENDOR </mat-header-cell>
      <mat-cell *matCellDef="let order" fxFlex="1 1 14%" class="stack-wrap-cell">
        {{ vendorName(order) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="model">
      <mat-header-cell *matHeaderCellDef fxFlex="1 1 12%"> MODEL </mat-header-cell>
      <mat-cell *matCellDef="let order" fxFlex="1 1 12%" class="stack-wrap-cell">
        {{ productField(order, 'model') }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="color">
      <mat-header-cell *matHeaderCellDef fxFlex="1 1 10%"> COLOR </mat-header-cell>
      <mat-cell *matCellDef="let order" fxFlex="1 1 10%" class="stack-wrap-cell">
        {{ productField(order, 'color') }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="group">
      <mat-header-cell *matHeaderCellDef fxFlex="0 0 80px"></mat-header-cell>
      <mat-cell *matCellDef="let order" fxFlex="0 0 80px" class="stack-wrap-cell">
        <strong *ngIf="groupLabel(order)">{{ groupLabel(order) }}</strong>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="patient">
      <mat-header-cell *matHeaderCellDef fxFlex="1 1 20%"></mat-header-cell>
      <mat-cell *matCellDef="let order" fxFlex="1 1 20%" class="stack-wrap-cell patient-cell">
        <button
          mat-button
          *ngIf="order.patient?._id"
          type="button"
          class="stack-patient-button"
          [routerLink]="['/admin/patient', order.patient._id]"
        >
          {{ patientName(order) }}
        </button>
        <span *ngIf="!order.patient?._id">{{ patientName(order) }}</span>
        <app-linked-job-badge
          *ngIf="order.linkSummary"
          [summary]="order.linkSummary"
          [patientId]="order.patient?._id"
        ></app-linked-job-badge>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="invoiceNumber">
      <mat-header-cell *matHeaderCellDef fxFlex="0 0 130px"> INVOICE # </mat-header-cell>
      <mat-cell *matCellDef="let order" fxFlex="0 0 130px" class="stack-wrap-cell">
        <button
          mat-button
          type="button"
          class="stack-patient-button"
          (click)="openOrder(order)"
        >
          <span [class.priority-redo-invoice]="order.redoPriority">
            {{ order.type }}&nbsp;–&nbsp;{{ order.invoiceNumber }}
          </span>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="notify">
      <mat-header-cell *matHeaderCellDef fxFlex="0 0 40px"></mat-header-cell>
      <mat-cell *matCellDef="let order" fxFlex="0 0 40px" class="stack-icon-cell">
        <button
          mat-icon-button
          type="button"
          class="stack-view-order-button"
          (click)="openNotify(order)"
          aria-label="Notify customer"
        >
          <mat-icon>visibility</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="log">
      <mat-header-cell *matHeaderCellDef fxFlex="0 0 48px"> LOG </mat-header-cell>
      <mat-cell *matCellDef="let order" fxFlex="0 0 48px" class="stack-icon-cell">
        <app-log-menu [order]="order" [small]="true" [alwaysShow]="true"></app-log-menu>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      [class.rush-notify-row]="row.redoPriority"
    ></mat-row>
  </mat-table>
</div>

<p *ngIf="!dataLoading && !orders.length" class="empty">NO JOBS WAITING FOR NOTIFICATION OR PICKUP</p>
